import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

import storeHelper from '@/store/helper'
import FileDownload from 'js-file-download'
import moment from 'moment'
// import axios from 'axios'
export class StaffService extends BaseService {
  static async getList(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.staff-get-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListSelect(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.staff-get-all-basic-info'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getSummary(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.staff-summary'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getStaffAFS() {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.staff.list-after-sales'),
        {}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async addStaff(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.staff.upsert-staff'),
        params
      )
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListTransfer(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.customer-get-list-transfer'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getRoleByUser(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.user-get-roles-by-user-id'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async setRole(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.staff.set-role'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateTypeSale(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.staff.up-type-sale'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getCityByUserId(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.get-user-info-by-id'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async changePassword(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.staff.change-password'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async fillPermissionByUser(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.user-get-permissions'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getStaffUnderSuperior(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.staff.list-staff-under-superior'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getStaffById(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.get-user-info-by-id'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async lockOfUnlockStaff(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.staff.set-status'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getTypeSaleByRegion(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.get-user-by-region-and-type'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getRegions() {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.unit.get-list-region'),
        {}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getRegionsConfig() {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.config.region'),
        {}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListRegions() {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.config.region'),
        {}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async resetPassword(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.staff.reset-password'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async deletedStaff(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.staff.delete-staff'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getAllCity(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.city-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDistictByCode(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.district-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async checkUsedPermission(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.user-role-is-used'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getProvinceRegion(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.unit.get-list-province-by-region'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getProvinceByRegionId(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.unit.get-all-province-by-region-id'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportStaff(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.staff.export-staff'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Report-statff' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async export(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.attn.export-attendance'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Report-attendance' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getStaffByIdSuperior(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.unit.get-list-subordinate'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListLowerGrade(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.unit.get-list-lower-grade'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getRoleList() {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.role-list'),
        {}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async superiors() {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.staff.list-manager'),
        {}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async downloadFileSample(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.staff.download-template-staff'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Import_NhanVien_Sample' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async downloadFileTemplateKPI(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.template-excel-kpi'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Import_SuaNV' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async historyUpload(params = {}) {
    try {
      const response = await this.request({ auth: true }).get(
        storeHelper.getUrl('cnps.staff.history-upload-file')
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async importStatffExcel(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.staff.import-staff'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateStatffExcelKPI(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.update-kpi-by-file'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        return new ResponseWrapper(response, response.data.data)
      }
      return response
    } catch (error) {}
  }

  static async getListAssigner(params = {}) {
    try {
      const response = await this.request({ auth: true }).get(
        storeHelper.getUrl('cnps.sur.list-assigner-merchant-to-sale')
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getUserKPIList(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.user-kpi-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async configAfs(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.staff.config-as'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListSubordinateV3(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.unit.get-list-subordinate-v3'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListByRegionTypeSale(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.get-user-by-regions-and-types'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async changeOfPersonIncharge(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.dfs.mc-sme.change-handler'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async assignTaskAll(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.css.task.assign-task-and-assign-staff'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateQrName(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.css.user-qr.update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getWardList(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.ward-list'),
        params
      )
      return response.data.data
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
